export class ProjectListPageConfig {
    public tabIndex = 0;
    public searchValue = null;
    public year = null;
    public manager = null;
    public type = null;
}
